import Box from '@/common/components/Box'
import ResumeItem from '@/common/components/ResumeItem'
import { TriangleAlert } from 'lucide-react'
import { useState } from 'react'
import { CancelMaintenanceWorkflowForwadingModal } from '../../../../CancelMaintenanceWorkflowFowardingModal'
import { useForwardingTabContext } from '../../../../../hooks/forwardings/useForwardingTabContext'
import useUserPermissions from '@/common/hooks/useUserPermissions'
import { formatDate } from '@/common/utils/formatters'
import DropdownMenu from '@/common/components/DropdownMenu'

export default function MaintenanceWorkflowForwardingActions() {
  const [cancelForwardingModalIsOpen, setCancelForwardingModalIsOpen] = useState<boolean>(false)
  
  const { forwarding, workflow } = useForwardingTabContext();

  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions()
  const userHasPermissionToCancelMaintenanceWorflowForwarding =
    isUserPermissionsPending || hasUserPermission('Client::Maintenance::Forwardings::Cancel')

  const showCancelMaintenanceWorkflowForwardingButton = userHasPermissionToCancelMaintenanceWorflowForwarding 
    && forwarding?.status !== 'canceled' 
    && forwarding?.status !== 'completed'
    && workflow?.status !== 'canceled'
    && workflow?.status !== 'completed'
    && !workflow?.can_create_new_forwarding

  return (
    <>
      <Box className="flex items-center justify-between p-4">
        <div className="flex items-center gap-4">
          <ResumeItem
            label="Data de criação"
            value={formatDate(new Date(forwarding.created_at))}
            labelClassName="text-white-400"
            valueClassName="text-md"
          />

          {forwarding.canceled_at && (
            <ResumeItem
            label="Data de cancelamento"
            value={formatDate(new Date(forwarding.canceled_at))}
            labelClassName="text-white-400"
            valueClassName="text-md"
            />
          )}
        </div>

        {showCancelMaintenanceWorkflowForwardingButton && (
          <DropdownMenu
            triggerClassName="bg-primary-blue hover:bg-primary-blue/80 justify-self-end"
            triggerLabel="Ações"
            menuPositionAlign="end"
            options={[
              {
                label: (
                  <p className="flex items-center gap-2 text-danger-soft">
                    <TriangleAlert className="max-w-5" />
                    Cancelar encaminhamento
                  </p>
                ),
                onClick: () => setCancelForwardingModalIsOpen(true),
                operationKlassToCheckPermission: "Client::Maintenance::Forwardings::Cancel",
              },
            ]}
          />
        )}
      </Box>
      <CancelMaintenanceWorkflowForwadingModal
        isOpen={cancelForwardingModalIsOpen}
        setIsOpen={setCancelForwardingModalIsOpen}
        workflowForwadingId={workflow?.current_forwarding?.id}
        workflowId={workflow?.id}
      />
    </>
  )
}
